import type { UserService } from "../../application/services/UserService";
import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { inject, onMounted, ref } from "vue";
import TsmSpinner from "../TsmSpinner";

export default {
  template: html,
  components: {
    TsmSpinner
  },
  setup() {
    const userService: UserService | undefined = inject("userService");
    const error = ref("")
    const showSpinner = ref(false)

    onMounted(async() => {
        const url = new URL(window.location.href);
        const code = url.searchParams.get("code");
        if (typeof code === "string" && code != "") {
          showSpinner.value = true;
          try{
            await userService?.processLoginCode(code)
            
          } catch (err){
            error.value = String(err)
          }
          if (error.value == ""){
            const afterLoginUrl = await userService?.getAfterLoginUrl() ?? "";
            if ("" == afterLoginUrl){
              error.value = "Im Login-Prozess ist ein Fehler aufgetreten. Bitte gehen Sie zurück auf die Kurs-Seite"
            } else {
              const url = new URL(afterLoginUrl);
              url.searchParams.delete("code"); // code = muss unbedingt entfernt werden
              const cleaned = url.toString();
              //console.log(cleaned)
              window.location.replace(cleaned);
            }
          }
          showSpinner.value = false;
        } else {
          const afterLoginUrl = await userService?.getAfterLoginUrl() ?? "";
          if (afterLoginUrl != "" && afterLoginUrl != window.location.href){
            // bei Logout muss diese Umleitung gemacht werden
              const url = new URL(afterLoginUrl);
              url.searchParams.delete("code"); // code = muss unbedingt entfernt werden
              const cleaned = url.toString();
              //console.log(cleaned)
              window.location.replace(cleaned);
          }
        }
    })
   
    return {
      error,
      showSpinner
    };
    
  }
}